module.exports = {
    __esModule: true,
    default: function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.debugPanel)+'"> <div class="'+(props.styles.closeButton)+'" data-hook="debug-panel-close-button" > x </div> <pre class="'+(props.styles.infoContainer)+'" data-hook="debug-panel-info-container" > </pre></div>';return out;
} 
  };


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/debug-panel/templates/debug-panel.dot.js
// module id = 91
// module chunks = 0